<!-- UN solo buscador, el conteo, la lente y la acción. La pregunta de Legal es una: «¿cuál me falta?». -->
<div class="pt-toolbar">
  <span class="p-input-icon-left pt-search">
    <i class="fa-solid fa-magnifying-glass"></i>
    <input
      pInputText
      type="text"
      [ngModel]="query"
      (ngModelChange)="onSearch($event)"
      placeholder="Buscar por folio o cliente"
      aria-label="Buscar arrendamientos"
    />
    <button type="button" class="pt-clear" *ngIf="query" (click)="clearSearch()" aria-label="Limpiar la búsqueda">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </span>

  <span class="pt-count" *ngIf="!loading && !error">
    <b>{{ total }}</b> {{ total === 1 ? 'arrendamiento' : 'arrendamientos' }}<ng-container *ngIf="query"> con «{{ query }}»</ng-container>
  </span>

  <!-- La lente: solo los que no tienen comité decidido. El número es de TODO el grupo, y por eso se pide aparte. -->
  <button
    type="button"
    class="pt-lente"
    [class.is-on]="lens === 'without-committee'"
    [attr.aria-pressed]="lens === 'without-committee'"
    (click)="toggleLens()"
    [pTooltip]="lens === 'without-committee' ? 'Quitar el filtro y ver todos' : 'Ver solo los que todavía no tienen comité decidido'"
    tooltipPosition="top"
  >
    <i class="fa-solid fa-gavel" aria-hidden="true"></i>
    <span>{{ lensLabel }}</span>
    <span class="pt-lente__n" *ngIf="withoutCommitteeTotal !== null">{{ withoutCommitteeTotal }}</span>
  </button>

  <div class="pt-acciones">
    <button
      *appIfHasPermission="['committee', 'create']"
      pButton
      type="button"
      [label]="actionLabel + ' (' + selectedRows.length + ')'"
      [icon]="group === 'originating' ? 'fa-solid fa-gavel' : 'fa-regular fa-file-lines'"
      class="p-button-sm"
      [disabled]="!selectedRows.length"
      (click)="bring()"
    ></button>
  </div>
</div>

<div class="pt-wrap">
  <table class="pt-table">
    <thead>
      <tr>
        <th class="pt-col-sel">
          <p-checkbox
            *appIfHasPermission="['committee', 'create']"
            [binary]="true"
            [ngModel]="allSelected"
            (onChange)="toggleAll()"
            [disabled]="!selectable.length"
            ariaLabel="Marcar todos los de esta página"
          ></p-checkbox>
        </th>
        <th>Folio</th>
        <th>Cliente</th>
        <th>Activo</th>
        <th>Estado</th>
        <th>Comité</th>
        <th>Última sesión</th>
        <th class="ta-c">Acta</th>
        <th class="pt-col-act"></th>
      </tr>
    </thead>

    <tbody *ngIf="loading">
      <tr *ngFor="let s of skeleton" aria-hidden="true">
        <td><p-skeleton width="1.2rem" height="1.2rem" borderRadius="4px"></p-skeleton></td>
        <td><p-skeleton height="0.8rem" width="5rem"></p-skeleton></td>
        <td><p-skeleton height="0.8rem" width="9rem"></p-skeleton></td>
        <td><p-skeleton height="0.8rem" width="8rem"></p-skeleton></td>
        <td><p-skeleton height="1.3rem" width="4.5rem" borderRadius="6px"></p-skeleton></td>
        <td><p-skeleton height="1.3rem" width="4.5rem" borderRadius="6px"></p-skeleton></td>
        <td><p-skeleton height="0.8rem" width="6rem"></p-skeleton></td>
        <td><p-skeleton height="0.8rem" width="2rem"></p-skeleton></td>
        <td><p-skeleton height="1.7rem" width="4.5rem" borderRadius="6px"></p-skeleton></td>
      </tr>
    </tbody>

    <tbody *ngIf="!loading">
      <tr *ngFor="let r of rows" class="pt-row" [class.is-sel]="isSelected(r)" [class.is-locked]="r.hasOpenMeeting">
        <td class="pt-col-sel">
          <!-- Con reunión abierta no se deja marcar: llevarlo a otra sesión daría 409. Se dice, no se esconde. -->
          <span
            *appIfHasPermission="['committee', 'create']"
            [pTooltip]="r.hasOpenMeeting ? 'Ya está en una sesión abierta' : ''"
            tooltipPosition="right"
          >
            <p-checkbox
              [binary]="true"
              [ngModel]="isSelected(r)"
              (onChange)="toggle(r)"
              [disabled]="r.hasOpenMeeting"
              [ariaLabel]="'Marcar ' + r.folio"
            ></p-checkbox>
          </span>
        </td>
        <td class="pt-folio">
          <a class="link-subsection" [routerLink]="['/lease', r._id]" [queryParams]="{ tab: 'comite' }">{{ r.folio || '—' }}</a>
        </td>
        <td>{{ r.clientName || '—' }}</td>
        <td class="cl-asset">{{ r.assetName || '—' }}</td>
        <td>
          <span class="pt-pill" [ngClass]="'is-' + (leasePill[r.status]?.tone || 'muted')">{{
            leasePill[r.status]?.label || r.status
          }}</span>
        </td>
        <td>
          <span
            *ngIf="r.committeeStatus; else sinComite"
            class="pt-pill"
            [ngClass]="'is-' + (committeePill[r.committeeStatus]?.tone || 'muted')"
          >
            {{ committeePill[r.committeeStatus]?.label || r.committeeStatus }}
          </span>
          <ng-template #sinComite><span class="pt-dash">—</span></ng-template>
        </td>
        <td class="pt-fecha">
          <a *ngIf="r.lastSessionId; else sinSesion" class="link-subsection" [routerLink]="['/comites/sesion', r.lastSessionId]">
            {{ r.lastMeetingDate ? (r.lastMeetingDate | date: 'dd/MM/yyyy') : 'Ver sesión' }}
          </a>
          <ng-template #sinSesion><span class="pt-dash">—</span></ng-template>
        </td>
        <td class="ta-c">
          <!-- Ícono + texto: el color solo no basta para leer «sí» y «no». -->
          <span class="cl-acta" [class.is-si]="r.hasMinutes">
            <i [class]="r.hasMinutes ? 'fa-solid fa-file-circle-check' : 'fa-regular fa-file'" aria-hidden="true"></i>
            {{ r.hasMinutes ? 'Sí' : 'No' }}
          </span>
        </td>
        <td class="pt-col-act">
          <button
            pButton
            type="button"
            label="Expediente"
            icon="fa-solid fa-arrow-up-right-from-square"
            class="p-button-sm p-button-text"
            pTooltip="Abrir la pestaña Comité del arrendamiento"
            tooltipPosition="left"
            [routerLink]="['/lease', r._id]"
            [queryParams]="{ tab: 'comite' }"
          ></button>
        </td>
      </tr>

      <tr *ngIf="!rows.length">
        <td colspan="9" class="pt-vacio">
          <ng-container *ngIf="error; else sinNada">{{ error }}</ng-container>
          <ng-template #sinNada>
            <ng-container *ngIf="query; else sinFiltro">
              Ningún arrendamiento coincide con «{{ query }}».
              <button type="button" class="pt-link" (click)="clearSearch()">Limpiar la búsqueda</button>
            </ng-container>
            <ng-template #sinFiltro>
              <ng-container *ngIf="lens === 'without-committee'; else grupoVacio"
                >Todos los arrendamientos de este grupo ya tienen comité.</ng-container
              >
              <ng-template #grupoVacio>No hay arrendamientos en este grupo.</ng-template>
            </ng-template>
          </ng-template>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Siempre que haya filas: aquí vive el selector de 30/60/90. -->
<p-paginator
  *ngIf="!loading && total"
  [first]="page * pageSize"
  [rows]="pageSize"
  [totalRecords]="total"
  [rowsPerPageOptions]="pageSizeOptions"
  (onPageChange)="onPage($event)"
  currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} arrendamientos"
  [showCurrentPageReport]="true"
></p-paginator>
